import React from 'react'

const NewHilites = () => {
  return (
    <div className='w-100 py-2'>
      <img src="" alt="" className='w-100' />
    </div>
  )
}

export default NewHilites